import { render } from "./typetrans-view.vue?vue&type=template&id=e47d312c"
import script from "./typetrans-view.vue?vue&type=script&setup=true&lang=js"
export * from "./typetrans-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/typetrans/typetrans-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e47d312c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e47d312c', __exports__)) {
    api.reload('e47d312c', __exports__)
  }
  
  module.hot.accept("./typetrans-view.vue?vue&type=template&id=e47d312c", () => {
    api.rerender('e47d312c', render)
  })

}


export default __exports__